import ProviderManager from "../components/providers/ProviderManager";

function Providers() {
  return <ProviderManager />;
}

export default Providers;
